var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer-card"},[_c('div',{staticClass:"answer-card__icon"},[_vm._v("✅")]),_c('h2',{staticClass:"answer-card__title"},[_vm._v("Correct!")]),_c('p',{staticClass:"answer-card__sub"},[_vm._v("Well done - you found the missing letter.")])])
}]

export { render, staticRenderFns }